import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"wrapper"},[_c(VApp,[_c(VMain,{staticClass:"mx-5"},[_c('PlayerForm',{staticClass:"my-5"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }